import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import styles from './../style/Podcast.module.scss'

import { Container, Image, Modal } from 'react-bootstrap'

import GreenButton from './GreenButton'
import WhiteBlockTitle from './WhiteBlockTitle'

const PlayBtn = () => (
  <svg className={styles.swiper_slyde_play} xmlns="http://www.w3.org/2000/svg" width={35} height={35} fill="none">
    <circle cx={17.5} cy={17.5} r={17.5} fill="#fff" />
    <path
      fill="#00C775"
      d="M22.881 15.556c1.497.865 1.497 3.026 0 3.89l-7.397 4.27c-1.497.865-3.369-.215-3.369-1.944V13.23c0-1.73 1.872-2.81 3.37-1.945l7.396 4.27Z"
    />
  </svg>
)

class Podcast extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.state = {
      activeIndex: 0,
      show_video_modal: false,
      currentVideo: null
    }
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext()
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev()
    }
  }

  handleSlideChange = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.setState({
        activeIndex: this.swiperRef.current.swiper.realIndex
      })
    }
  }

  openVideoModal = (videoData) => {
    this.setState({ 
      show_video_modal: true,
      currentVideo: videoData
    });
  }

  closeVideoModal = () => {
    this.setState({ 
      show_video_modal: false,
      currentVideo: null
    });
  }

  extractVideoId(url) {
    if (!url) return null;
    
    // Rutube
    const rutubeRegExp1 = /rutube\.ru\/video\/([a-zA-Z0-9]+)/;
    const rutubeRegExp2 = /rutube\.ru\/play\/embed\/([a-zA-Z0-9]+)/;
    
    // YouTube
    const youtubeRegExp = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    
    // YouTube Shorts
    const shortsRegExp = /youtube\.com\/shorts\/([^"&?\/\s]{11})/;
    
    const rutubeMatch1 = url.match(rutubeRegExp1);
    const rutubeMatch2 = url.match(rutubeRegExp2);
    const youtubeMatch = url.match(youtubeRegExp);
    const shortsMatch = url.match(shortsRegExp);
    
    if (rutubeMatch1 && rutubeMatch1[1]) return { id: rutubeMatch1[1], type: 'rutube' };
    if (rutubeMatch2 && rutubeMatch2[1]) return { id: rutubeMatch2[1], type: 'rutube' };
    if (youtubeMatch && youtubeMatch[1]) return { id: youtubeMatch[1], type: 'youtube' };
    if (shortsMatch && shortsMatch[1]) return { id: shortsMatch[1], type: 'youtube' };
    
    return null;
  }

  getEmbedUrl(videoInfo) {
    if (!videoInfo) return null;
    
    const { id, type } = videoInfo;
    
    if (type === 'rutube') {
      return `https://rutube.ru/play/embed/${id}/`;
    } else if (type === 'youtube') {
      return `https://www.youtube.com/embed/${id}`;
    }
    
    return null;
  }

  formatSlideNumber = (index) => {
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {
    const { data } = this.props
    const { activeIndex, show_video_modal, currentVideo } = this.state

    const videoInfo = currentVideo ? this.extractVideoId(currentVideo.href) : null;
    const embedUrl = videoInfo ? this.getEmbedUrl(videoInfo) : '';

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={data?.text_r || ``}
            className={styles.title}
          />

          {/* Модальное окно для видео */}
          <Modal 
            show={show_video_modal} 
            onHide={this.closeVideoModal}
            size="lg"
            centered
            className={styles.video_modal}
          >
            <Modal.Header closeButton>
              <Modal.Title>{currentVideo?.name || 'Видео'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
              {embedUrl ? (
                <div className={styles.video_container}>
                  <iframe
                    src={embedUrl}
                    width="100%"
                    height="405"
                    frameBorder="0"
                    style={{ border: 'none' }}
                    allow="clipboard-write; autoplay; encrypted-media; picture-in-picture"
                    webkitAllowFullScreen
                    mozallowfullscreen
                    allowFullScreen
                    title={currentVideo?.name || 'Видео'}
                  />
                </div>
              ) : (
                <p>Неверная ссылка на видео</p>
              )}
            </Modal.Body>
          </Modal>

          <div className={styles.content}>
            <div className={styles.lblock}>
              <div onClick={() => this.openVideoModal({
                href: data?.href,
                name: `Подкаст`
              })} className={styles.video}>
                <Image src={data?.image} width={594} height={278} alt={`Смотреть видео`} />
                <div className={styles.video_btn}>
                  <GreenButton
                    text={`Смотреть видео`}
                    width={145}
                    action={() => { }}
                    svg={(
                      <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.5 4.63397C9.16667 5.01888 9.16667 5.98113 8.5 6.36603L1.75 10.2631C1.08333 10.648 0.25 10.1669 0.25 9.39711L0.250001 1.60289C0.250001 0.833085 1.08333 0.35196 1.75 0.73686L8.5 4.63397Z" fill="#00C775" />
                      </svg>
                    )}
                  />
                </div>
              </div>
              <div className={styles.lblock_bottom}>
                <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text}} />
                <a className={styles.lblock_bottom_btn} style={{ textDecoration: `none` }} href={`https://www.youtube.com/@Bezaev`} target='_blank' rel="nofollow">
                  <GreenButton
                    text={`Перейти на YouTube канал`}
                    width={199}
                    action={() => { }}
                    className={styles.lblock_bottom_btn}
                    svg={(
                      <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path style={{ stroke: `none` }} d="M16.6551 1.80064C16.4622 1.14092 15.8975 0.620758 15.1812 0.443141C13.8726 0.113281 8.63838 0.113281 8.63838 0.113281C8.63838 0.113281 3.40412 0.113281 2.09556 0.430454C1.39307 0.608071 0.814544 1.14092 0.621703 1.80064C0.277344 3.0059 0.277344 5.50522 0.277344 5.50522C0.277344 5.50522 0.277344 8.01722 0.621703 9.20979C0.814544 9.86951 1.37929 10.3897 2.09556 10.5673C3.4179 10.8972 8.63838 10.8972 8.63838 10.8972C8.63838 10.8972 13.8726 10.8972 15.1812 10.58C15.8975 10.4024 16.4622 9.8822 16.6551 9.22248C16.9994 8.01722 16.9994 5.5179 16.9994 5.5179C16.9994 5.5179 17.0132 3.0059 16.6551 1.80064Z" fill="#FF0000" />
                        <path style={{ stroke: `none` }} d="M6.97168 7.81335L11.3244 5.50433L6.97168 3.19531V7.81335Z" fill="white" />
                      </svg>
                    )}
                  />
                </a>
              </div>
            </div>
            <div className={styles.rblock} style={{ backgroundImage: `url(${data?.fon})` }}>
              <div className={styles.slydenav}>
                <div className={styles.slydenav_num}>{this.formatSlideNumber(activeIndex)}</div>
                <div className={styles.slydenav_sep}></div>
                <div className={styles.slydenav_btns}>
                  <div className={styles.slydenav_btn} onClick={this.prevSlide}>
                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.3212 4.49913H1.67882M1.67882 4.49913L5.53576 8.35608M1.67882 4.49913L5.53576 0.642184" stroke="black" strokeLinecap="round" />
                    </svg>
                  </div>
                  <div className={styles.slydenav_btn} onClick={this.nextSlide}>
                    <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="black" strokeLinecap="round" />
                    </svg>
                  </div>
                </div>
              </div>

              <Swiper
                ref={this.swiperRef}
                modules={[Navigation]}
                spaceBetween={0}
                slidesPerView={1}
                breakpoints={{
                  576: {
                    slidesPerView: 3
                  }
                }}
                loop={true}
                onSlideChange={this.handleSlideChange}
                onSwiper={(swiper) => {
                  this.setState({ activeIndex: swiper.realIndex })
                }}
                className={styles.swiper_container}
              >
                {data.slides.map((slide, index) => (
                  <>
                    <SwiperSlide key={index + `_1`}>
                      <div className={styles.swiper_slyde}>
                        <div 
                          className={styles.swiper_slyde_el} 
                          onClick={() => this.openVideoModal({
                            href: slide?.href1,
                            name: slide?.name1
                          })}
                          role="button"
                          tabIndex={0}
                          onKeyUp={(e) => e.key === 'Enter' && this.openVideoModal({
                            href: slide?.href1,
                            name: slide?.name1
                          })}
                        >
                          <PlayBtn />
                          <Image src={slide?.image1} width={161} height={265} alt={slide?.name1} />
                          <div dangerouslySetInnerHTML={{__html: slide.name1}} />
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide key={index + `_2`}>
                      <div className={styles.swiper_slyde}>
                        <div 
                          className={styles.swiper_slyde_el} 
                          onClick={() => this.openVideoModal({
                            href: slide?.href2,
                            name: slide?.name2
                          })}
                          role="button"
                          tabIndex={0}
                          onKeyUp={(e) => e.key === 'Enter' && this.openVideoModal({
                            href: slide?.href2,
                            name: slide?.name2
                          })}
                        >
                          <PlayBtn />
                          <Image src={slide?.image2} width={161} height={265} alt={slide?.name2} />
                          <div dangerouslySetInnerHTML={{__html: slide.name2}} />
                        </div>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide key={index + `_3`}>
                      <div className={styles.swiper_slyde}>
                        <div 
                          className={styles.swiper_slyde_el} 
                          onClick={() => this.openVideoModal({
                            href: slide?.href3,
                            name: slide?.name3
                          })}
                          role="button"
                          tabIndex={0}
                          onKeyUp={(e) => e.key === 'Enter' && this.openVideoModal({
                            href: slide?.href3,
                            name: slide?.name3
                          })}
                        >
                          <PlayBtn />
                          <Image src={slide?.image3} width={161} height={265} alt={slide?.name3} />
                          <div dangerouslySetInnerHTML={{__html: slide.name3}} />
                        </div>
                      </div>
                    </SwiperSlide>
                  </>
                ))}
              </Swiper>
            </div>
          </div>
        </Container>
      </section>
    )
  }
}

Podcast.propTypes = {
  data: PropTypes.object
}

Podcast.defaultProps = {
  data: {}
}

export default Podcast